<template>
  <!-- <div class="row"> -->
      <!-- <div class="col-md-8 border-left border-right"> -->
      <!-- <div class="col-md-12"> -->
      <div>
        <transition name="fade" mode="out-in">
         <router-view :key="$route.fullPath" class="mb-3" name="makeaclaim" />
        </transition>
      </div>
      <!-- <div class="col-md-4 border-right">
      <div class="col-md-3 border-right">
          <div class="mb-3">
            <button class="btn btn-outline-danger" @click="handleStartAgainClick()"><strong>Start again</strong></button>&nbsp;
            <button class="btn btn-outline-success" @click="handleSaveForLaterClick()"><strong>Save for later</strong></button>
          </div>
          <form-progress />
      </div> -->
  <!-- </div> -->
</template>

<script>

// import { mapActions } from 'vuex'
import standaloneClaimForm from '@/mixins/standaloneClaimForm'

import formProgress from '@/components/FormProgress.vue'

export default {
  name: 'makeAClaim',
  components: {
    formProgress
  },
  mixins: [
    standaloneClaimForm
  ],
  data: () => {
    return {

    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {
    // ...mapActions({
    //   //reset:'claimform/reset'
    // }),
    handleSaveForLaterClick () {
      this.saveClaimForm()
    },
    handleStartAgainClick () {
      // reset claim form
      this.reset()

      // redirect to home page...
      this.$router.push('/makeaclaim')
    }
  }
}
</script>
